import { Phone, Mail, ArrowUpRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-28 md:py-40 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <div className="font-mono-label text-[11px] text-violet-400 mb-6">
            04 / Let's talk
          </div>
          <h2
            data-testid="contact-heading"
            className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black tracking-tighter leading-[0.95] text-white max-w-5xl"
          >
            Have a project in mind?
            <br />
            <span className="text-violet-400 italic font-light">Let's build it.</span>
          </h2>

          <p className="mt-8 max-w-2xl text-base md:text-lg text-white/60 leading-relaxed font-light">
            The fastest way to get started is to reach out directly. I read every message, and
            you'll usually hear back from <strong className="text-white font-semibold">Max</strong> the
            same day.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
          <Reveal delay={120} y={32}>
          <a
            href="tel:+12013065226"
            data-testid="contact-phone-link"
            className="card-glass mega-link group relative overflow-hidden rounded-2xl p-8 md:p-10 flex flex-col gap-6"
          >
            <div className="flex items-center justify-between">
              <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-violet-500/15 border border-violet-400/30">
                <Phone size={20} className="text-violet-300" />
              </div>
              <ArrowUpRight
                size={22}
                className="text-white/40 group-hover:text-violet-300 group-hover:-translate-y-1 group-hover:translate-x-1 transition-all"
              />
            </div>
            <div>
              <div className="font-mono-label text-[10px] text-white/40 mb-3">Phone</div>
              <div className="font-display text-3xl md:text-4xl font-bold text-white group-hover:text-violet-300 transition-colors">
                201-306-5226
              </div>
            </div>
          </a>
          </Reveal>

          <Reveal delay={220} y={32}>
          <a
            href="mailto:rmstuss@gmail.com"
            data-testid="contact-email-link"
            className="card-glass mega-link group relative overflow-hidden rounded-2xl p-8 md:p-10 flex flex-col gap-6"
          >
            <div className="flex items-center justify-between">
              <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-violet-500/15 border border-violet-400/30">
                <Mail size={20} className="text-violet-300" />
              </div>
              <ArrowUpRight
                size={22}
                className="text-white/40 group-hover:text-violet-300 group-hover:-translate-y-1 group-hover:translate-x-1 transition-all"
              />
            </div>
            <div>
              <div className="font-mono-label text-[10px] text-white/40 mb-3">Email</div>
              <div className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-white group-hover:text-violet-300 transition-colors break-all">
                rmstuss@gmail.com
              </div>
            </div>
          </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
